import { render, staticRenderFns } from "./Intercom.vue?vue&type=template&id=90671c9c&"
import script from "./Intercom.vue?vue&type=script&lang=js&"
export * from "./Intercom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports